if($('.filter-section').length){
    mhFilter();
    document.addEventListener('ShoptetDOMContentLoaded', function() {
        mhFilter();
    }); 
    document.addEventListener('ShoptetDOMPageContentLoaded', function() {
        mhFilter();
    }); 
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
        mhFilter();
    }); 
    
}

function mhFilter(){
    const $activeLabels = $('.filter-label.active').not('.chooseFilters .filter-label');
    const hasActive = $activeLabels.length > 0;
    let $wrapper = $('.chooseFilters');

    if (!hasActive) {
    $wrapper.remove();
    } else {

        if (!$wrapper.length) {
            $wrapper = $('<div class="chooseFilters"><div class="inner"></div></div>')
                .insertBefore('#category-header');
        }

        $wrapper.empty();

        // vytvoření struktury
        const $title = $('<div class="chooseFiltersTitle">Vaše filtry:</div>').appendTo($wrapper);
        const $inner = $('<div class="inner"></div>').appendTo($wrapper);

        $activeLabels.each(function () {
            $('body').addClass('activeFilters');
            $(this).closest('.filter-section').addClass('openFilter');

            const $label = $(this).clone();
            const filterName = $(this).closest('.filter-section').find('h4').first().text();

            if (filterName) {
                $label.prepend('<span class="filterName">' + filterName + ': </span>');
            }

            // 👉 TADY JE HLAVNÍ ZMĚNA
            $inner.append($label);

        });

        const $clear = $('#clear-filters');

        if ($clear.length) {
            const $clearClone = $clear.clone(true, true);

            $clearClone
                .addClass('clear-all-filters')
                .find('a')
                .text('Zrušit');

            $wrapper.append($clearClone); // 👉 místo $inner
        }
    }

    $('html').on('click', '#filters .filter-section h4', function(){
        var $currentSection = $(this).closest('.filter-section');
        $('#filters .filter-section').not($currentSection).removeClass('openIt');
        $(this).closest('.filter-section').toggleClass('openIt')
    })
    if(!$('.slider-wrapper .sliderForm').length){
        $('.slider-wrapper').append('<div class="sliderForm"></div>').addClass('filter-section').appendTo('#category-filter-hover');
        $('.slider-wrapper .sliderForm').append($('.slider-wrapper .slider-header'), $('.slider-wrapper .slider-content'))
    }
   
    if(!$('.filter-section-boolean h4').length){
        $('.filter-section-boolean').prepend('<h4><span>Štítek</span></h4>').appendTo('#category-filter-hover');
    }
   
    var productSum = parseFloat($('.category-header>div strong').text());
    if(productSum<2){
        productSumTotal = ' produkt'
    }
    if(productSum>1 && productSum < 5){
        productSumTotal = ' produkty'
    }
    if(productSum>5){
        productSumTotal = ' produktů'
    }
    $('.category-header .productSum').remove()
    $('.category-header').append('<div class="productSum">Celkem nalezeno '+$('.category-header>div strong').text()+''+productSumTotal+'</div>')
    if(!$('.productDisplay').length){
        $('.category-header').append('<div class="productDisplay"><span class="grid" data-use="grid"></span><span class="rows" data-use="rows"></span></div>')
    }
    if (!localStorage.getItem('productDisplay')) {
        localStorage.setItem('productDisplay', 'grid');
    }
    let storedValue = localStorage.getItem('productDisplay');
    $(".productDisplay span").each(function () {
        if ($(this).data('use') === storedValue) {
            $(this).addClass('active');
            $(this).closest('#content').find('#products').addClass('display-'+storedValue)
        }
    });
    $('.filter-section form').each(function() {
        var $form = $(this);
        var $divs = $form.find('div');
        if ($divs.length > 11) {
          $divs.slice(11).hide();
          var $toggleBtn = $('<span class="toggle-filters arrowDown">Zobrazit všechny</span>');
          if(!$(this).find('.toggle-filters').length){
            $form.append($toggleBtn);
          }
          
          $toggleBtn.on('click', function() {
            if ($toggleBtn.text() === 'Zobrazit všechny') {
              $divs.show();
              $toggleBtn.text('Zobrazit méně').removeClass('arrowDown').addClass('arrowUp');
            } else {
              $divs.slice(11).hide();
              $toggleBtn.text('Zobrazit všechny').removeClass('arrowUp').addClass('arrowDown');
            }
          });
        }
      });
}

$(".productDisplay span").click(function () {
    let selectedValue = $(this).data('use');
    localStorage.setItem('productDisplay', selectedValue);
    $(".productDisplay span").removeClass('active');
    $(this).closest('#content').find('#products').removeClass('display-grid').removeClass('display-rows')
    $(this).addClass('active');
    $(this).closest('#content').find('#products').addClass('display-'+selectedValue)
});


